import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { I18nHelper, Translations } from '../../Lib/Helper/I18nHelper';
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import swal from 'sweetalert2';
import EXIF from "exif-js";
import { AccountRentalData, AccountRentalDataInitData } from "../Account/AccountRentalData";
import { IAxBirthDateInitData } from "../Global/AxBirthDateInputTriple";
import { CustomerLessonProperties, InitCustomerProps } from "../Account/CustomerLessonProperties";

declare let Dropzone: Dropzone;

@ModuleName("MyFamily")
export class MyFamily implements AxInit {
    public AxLoading: AxLoading;
    private familyMembers: IFamilyMember[];
    private ticketImgBase64: string;
    private ticketDropzone: Dropzone;
    private cropper: Cropper;

    private _accountRentalData: AccountRentalData = new AccountRentalData();
    private _customerLessonProps: CustomerLessonProperties = new CustomerLessonProperties();
    private lessonPropsParentId: string;
    private rentalParentId: string;
    private ciDatePattern: string;

    private activeDeleteModalAccountNo: number;
    private activeEditModalAccountNo: number;
    private tempFamImageSrc: string;

    private dobSettings: IAxBirthDateInitData;

    constructor(private i18nHelper = new I18nHelper()) { }

    AxInit(init: IMyFamilyData): void {
        this.familyMembers = init.famMembers;
        this.AxLoading = new AxLoading();
        this.rentalParentId = init.parentId;
        this.ciDatePattern = init.ciDatePattern;
        this.dobSettings = init.dobInit;
        this.lessonPropsParentId = init.lessonPropsParentId;
        this._customerLessonProps.AxInit(new InitCustomerProps(init.lessonPropsParentId, ""));

        if (window.location.hash != '') {
            $('a[href="' + window.location.hash + '"]').tab('show');
        }

        this.initTicketDropzone();
        this.initFamilyMemberCardButtonEvents();
        this.initFamilyMemberEditModalOnShowEvents();
        this.initDeleteMemberModalEvents();

        $('#imageFamTicket_update_modal').on('hidden.bs.modal', () => {
            this.userImageFamTicketBack();
        });

        $('#family_edit_modal').on('hidden.bs.modal', () => {
            this.resetTempFamImageSrc();
        });
    }

    // initFamilyMemberCardButtonEvents
    initFamilyMemberCardButtonEvents() {
        $('.Delete_member').click((e) => {
            this.activeDeleteModalAccountNo = parseInt($(e.delegateTarget).attr('member-data'));
            $('#FamMember_delete_modal').modal('show');
        });
    }

    // initFamilyMemberEditModalOnShowEvents
    initFamilyMemberEditModalOnShowEvents() {
        $('.family_edit_modal').on('show.bs.modal', (e) => {
            this.initPartialEvents(e);
        });
    }

    // initDeleteMemberModalEvents
    initDeleteMemberModalEvents() {
        $('.FamMember_delete_modal_cancel').click((e) => {
            $('#FamMember_delete_modal').modal('hide');
        });

        $('.FamMember_delete_modal_delete').click((e) => {
            this.deleteFamMember(this.activeDeleteModalAccountNo);
        });
    }

    // initTicketDropZoneAfterSuccessEvents
    initTicketDropZoneAfterAcceptEvents() {
        $('.profile__family_ticket-back').click((e) => {
            this.userImageFamTicketBack();
        });

        $('.profile__family_ticket-send').click((e) => {
            this.sendFamTicketDropzone();
        });
    }

    // initPartialEvents
    initPartialEvents(e: any) {
        let $target = $(e.delegateTarget);

        let accNr = $target.attr('data-customerAccNr');
        let onSubmitAction = $target.attr('data-onsubmitaction') ?? true;
        this.AxLoading.ShowLoadingIndicator($target.find('.family_edit_modal_formholder')[0]);

        AxessViewer.loadPartialView('/Profile/GetEditFamilyMemberFormPartial', { familyMemberAccountNo: accNr, onSubmitAction: onSubmitAction }, (result) => {
            this.activeEditModalAccountNo = parseInt(accNr);
            $(e.delegateTarget).find('.family_edit_modal_formholder').html(result);
            this.initFormPartialEvents(e);
        }, { dataType: 'html' });
    }

    // initFormPartialEvents
    initFormPartialEvents(event: any) {
        this._accountRentalData.AxInit(new AccountRentalDataInitData(this.rentalParentId));
        this._customerLessonProps.AxInit(new InitCustomerProps(this.lessonPropsParentId, ""));

        if (this.familyMembers != undefined) {
            this.setFamilyMemberTicketImageInPartial();
        }

        this.dobSettings.parentId = `#${event.delegateTarget.id}`;
        this.dobSettings.outputTarget = `input[name=DateOfBirthCi]`;
        this.dobSettings.setBirthDate = $(event.delegateTarget).find('input[name=DateOfBirthCi]').val() as string;
        AxLoad.LoadModule('AxBirthDateInputTriple', this.dobSettings);

        this.AxLoading.HideLoadingIndicator($(event.delegateTarget).find('.family_edit_modal_formholder')[0]);

        $('.profile__family_ticket-open').click((x) => {
            this.openImageFamTicketUpload();
        });
    }

    // openImageFamTicketUpload
    openImageFamTicketUpload() {
        $('#family_edit_modal_' + this.activeEditModalAccountNo).modal('hide');

        $('#imageFamTicket_update_modal').modal({
            backdrop: 'static',
        });
    }

    // setFamilyMemberTicketImageInPartial
    setFamilyMemberTicketImageInPartial() {
        let famMember = this.getFamilyMemberByAccNo(this.activeEditModalAccountNo);

        if (famMember != null && typeof famMember.productImagePath != 'undefined') {

            $('#imageFamTicket_update_modal #personProjNr').val(famMember.personProjNr);
            $('#imageFamTicket_update_modal #personPosNr').val(famMember.personPosNr);
            $('#imageFamTicket_update_modal #personNr').val(famMember.personNr);

            $('#imageFamTicket_update_modal .user_image_holder img').attr('src', famMember.productImagePath);
            $('#famMemImage').attr("src", famMember.productImagePath);

        } else {
            console.error('setFamilyMemberTicketImageInPartial: famMember null');
        }

        if (!this.tempFamImageSrc) {
            $('#famMemImage').attr("src", this.tempFamImageSrc);
        }

        $('#imageFamTicket_update_modal .user_image_holder').removeClass('kt-hidden');
    }

    // deleteFamMember
    deleteFamMember(accNo: number) {
        AxessViewer.loadPartialView('/ProfileSettings/DeleteFamilyMember', { number: accNo }, () => { }, { reload: true });
    }

    // sendFamTicketDropzone
    sendFamTicketDropzone() {
        $('#ticketImgBase64').val(this.ticketImgBase64);
        this.ticketDropzone[0].dropzone.processQueue();
    }

    // userImageFamTicketBack
    userImageFamTicketBack() {
        $('.imageFamTicket-upload-2').css('display', 'none');
        $('.imageFamTicket-upload-1').css('display', 'block');
        $('#imageFamTicket_update_modal').modal('hide');
        $('#family_edit_modal_' + this.activeEditModalAccountNo).modal('show');
        this.cropper.destroy();
        this.ticketDropzone[0].dropzone.removeAllFiles(true);
    }

    // getFamilyMemberByAccNo
    getFamilyMemberByAccNo(accNo: number): IFamilyMember {
        let famMem = this.familyMembers.find(x => x.cNr === accNo);
        return famMem;
    }

    // resetTempFamImageSrc
    resetTempFamImageSrc() {
        this.tempFamImageSrc = '';
    }

    resetFamilyMemberForm() {
        $('#EditFirstName').val("");
        $('#EditLastName').val("");
        $('#EditDayOfBirth').val("");
        $('#EditEmail').val("");
        $('#famMemImage').attr("src", `/Images/pers/placeholder1.png`);
        $('#EditPersonProjNr').val("");
        $('#EditPersonPosNr').val("");
        $('#EditPersonNr').val("");
        this._accountRentalData.resetDropdowns();
    }

    initTicketDropzone() {
        this.ticketDropzone = $('#AvatarFamTicketUploadForm').dropzone({
            paramName: "AvatarFamTicketUploadForm",
            maxFilesize: 10,
            uploadMultiple: false,
            maxFiles: 1,
            acceptedFiles: 'image/*',
            autoProcessQueue: false,
            thumbnailWidth: 138,
            thumbnailHeight: 171,
            init: () => { },
            sending: (file, xhr, formData) => {
                $('#imageFamTicket_update_modal_body').addClass('loading');
            },
            accept: (file, done) => {
                this.initTicketDropZoneAfterAcceptEvents();

                // @ts-ignore
                EXIF.getData(file, () => {
                    let allMetaData = EXIF.getAllTags(this);
                    $('#imageFamTicketOrientation').val(allMetaData.Orientation);
                    $('#editimageorientation').val(allMetaData.Orientation);

                    const reader = new FileReader();
                    reader.onload = (event) => {
                        this.ticketImgBase64 = (event.target.result as string).split('base64,')[1];

                        $('#imageFamTicket').attr('src', event.target.result as string);

                        $('#famMemImage').attr('src', event.target.result as string);

                        let imageFamTicket = document.getElementById('imageFamTicket') as HTMLImageElement;

                        // @ts-ignore
                        this.cropper = new Cropper(imageFamTicket, {
                            aspectRatio: 138 / 171,
                            zoomable: false,
                            viewMode: 2,
                            crop: (event) => {
                                let y = event.detail.y;
                                if (y < 0) {
                                    y = 0;
                                }
                                $('#imageFamTicketPosX').val(Math.round(event.detail.x));
                                $('#imageFamTicketPosY').val(Math.round(y));
                                $('#imageFamTicketSizeX').val(Math.round(event.detail.width));
                                $('#imageFamTicketSizeY').val(Math.round(event.detail.height));
                                $('#editimageposx').val(Math.round(event.detail.x));
                                $('#editimageposy').val(Math.round(y));
                                $('#editimagesizex').val(Math.round(event.detail.width));
                                $('#editimagesizey').val(Math.round(event.detail.height));
                            },
                        });

                        $('.imageFamTicket-upload-1').css('display', 'none');
                        $('.imageFamTicket-upload-2').css('display', 'block');
                    };
                    reader.readAsDataURL(file);
                    done();
                });
            },
            success: (file, resp) => {
                if (resp["error"] === false) {
                    swal.fire({
                        title: this.i18nHelper.GetTranslation(Translations.Success) + '!',
                        icon: 'success',
                        text: resp['message'],
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        $('.m-content > .alert-danger').remove();
                        location.reload();
                    });

                } else {
                    swal.fire({
                        title: this.i18nHelper.GetTranslation(Translations.Error) + '!',
                        text: resp['message'],
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            }
        });
    }
}

interface IMyFamilyData {
    parentId: string;
    famMembers: IFamilyMember[];
    ciDatePattern: string;
    lessonPropsParentId: string;
    dobInit: IAxBirthDateInitData;
}

interface IFamilyMember {
    cNr: number;
    firstName: string;
    lastname: string;
    dateofbirth: string;
    mail: string;
    imagePath: string;
    productImagePath: string;
    personProjNr: number;
    personPosNr: number;
    personNr: number;
    weight: number;
    height: number;
    shoeSize: number;
    skiLevel: number;
}